<template>
    <!-- <div>
        <b-container class="px-0"> -->
            <card-layout
                v-if="toplineData && toplineData['control_sim'] != null && dataMode === 'polling'"
                title="Probability of Democratic Control"
                card-class="mb-0 border-bottom-0"
            >
                <b-table id="democratic-control" :items="items" :fields="fields" class="m-1">
                    <template #cell(percentage)="{ item }">
                        <div class="py-2" style="font-size: 24px;" :style="'color: ' + styles.demColor1">
                        {{ item.control_sim !== null ? (item.control_sim * 100).toFixed(1) + '%' : '' }}
                        </div>
                    </template>
                    <template #cell(dial)="{ item }">
                        <div 
                            style="width: 75px; margin: 0 auto;"
                        >

                        <dial-radial-bar-sparkline
                            :rotation="item.control_sim !== null
                            ? ((100 - (item.control_sim * 100)) * 1.8) - 90
                            : 0"
                        />
                        </div>
                    </template>
                    <!-- empty column -->
                    <template #cell(spacer)>
                    </template>
                </b-table>
            </card-layout>
        <!-- </b-container>
    </div> -->
</template>

<script setup>
    import { onMounted, computed, ref } from 'vue';
    import { storeToRefs } from 'pinia';
    import CardLayout from './details/CardLayout.vue'
    import DialRadialBarSparkline from "./sparklines/DialRadialBarSparkline.vue"
    import styles from '../../sass/_export.module.scss';

    // Stores
    import { useToplinesStore } from '../stores/toplines';

    const toplinesStore = useToplinesStore();

    // Store refs
    const {
        toplineData,
        dataMode,
    } = storeToRefs(toplinesStore);

    onMounted(() => {
        console.log('TotalsApp Component mounted.');
    });
    
    const fields = [
        { key: 'percentage', label: '', tdClass: 'bg-white align-middle' },
        { key: 'dial', label: '', tdClass: 'bg-white' },
        { key: 'spacer', label: '', tdClass: 'bg-white' }
    ]

    const items = computed(() => 
        [{ control_sim: toplineData.value !== null && toplineData.value.control_sim !== null ? toplineData.value.control_sim : 0 }]
    );
</script>
<style>
#democratic-control td:nth-child(2) {
    text-align: center;
}
#democratic-control td:nth-child(3) {
    width: 10%;
}
</style>
